import React, { useState, useEffect } from 'react';
import Highlighter from 'react-highlight-words';
import { Input, Button, Space, Table, Modal, Tag } from 'antd';
import { DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';
import { get } from 'lodash-es';
import ReactImage from '../../components/Image';

const ExpertBuyOrderManagement = ({ expertBuyOrders, fetchExpertBuyOrders }) => {
	const [searchText, setSearchText] = useState('');
	const [searchedColumn, setSearchedColumn] = useState('');

	useEffect(() => {
		fetchExpertBuyOrders();
	}, []);

	const getColumnSearchProps = (dataIndex) => ({
		filterDropdown: function filterDropdown({ setSelectedKeys, selectedKeys, confirm, clearFilters }) {
			return (
				<div style={{ padding: 8 }}>
					<Input
						placeholder={`Search ${dataIndex}`}
						value={selectedKeys[0]}
						onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
						onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
						style={{ width: 188, marginBottom: 8, display: 'block' }}
					/>
					<Space>
						<Button
							type="primary"
							onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
							icon={<SearchOutlined />}
							size="small"
							style={{ width: 90 }}
						>
							Search
						</Button>
						<Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
							Reset
						</Button>
					</Space>
				</div>
			);
		},
		filterIcon: function filter(filtered) {
			return <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />;
		},
		onFilter: (value, record) => {
			return get(record, dataIndex).toString().toLowerCase().includes(value.toLowerCase());
		},
		render: function render(text) {
			return searchedColumn === dataIndex ? (
				<Highlighter
					highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
					searchWords={[searchText]}
					autoEscape
					textToHighlight={text ? text.toString() : ''}
				/>
			) : (
				text
			);
		},
	});

	const handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
		setSearchText(selectedKeys[0]);
		setSearchedColumn(dataIndex);
	};

	const handleReset = (clearFilters) => {
		clearFilters();
		setSearchText('');
	};

	const columns = [
		{
			title: 'Order Date',
			dataIndex: 'createdAt',
			key: 'createdAt',
			...getColumnSearchProps('createdAt'),
		},
		{
			title: 'Payments Status',
			dataIndex: 'paymentStatus',
			key: 'paymentStatus',
			...getColumnSearchProps(['status']),
			render: function payment(text, record) {
				return (
					<Space size="middle">
						<Tag>{record?.paymentStatus === 0 ? 'Pending' : 'Paid'}</Tag>
					</Space>
				);
			},
		},
		{
			title: 'User',
			dataIndex: ['user', 'fullName'],
			key: 'fullName',
			...getColumnSearchProps(['user', 'fullName']),
			render: function user(text, record) {
				return <Space size="middle">{`${record?.user?.fullName}`}</Space>;
			},
		},
	];

	return (
		<div>
			<Table
				dataSource={expertBuyOrders}
				columns={columns}
				rowKey={(record) => record._id}
				size="small"
				scroll={{ x: true }}
			/>
			<Modal />
		</div>
	);
};

const mapStateToProps = (store) => ({
	expertBuyOrders: store.orders.expertBuyOrders,
});

const mapDispatchToProps = (dispatch) => ({
	fetchExpertBuyOrders: () => dispatch(Actions.fetchExpertBuyOrders()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpertBuyOrderManagement);
